import { Image } from '@educator/components/Image'

interface TestimonialAvatarProps {
  src: string
  name: string
}

export const TestimonialAvatar = ({ src, name }: TestimonialAvatarProps) => (
  <Image
    src={src}
    alt={name}
    width={64}
    height={64}
    className='h-16 w-16 shrink-0 rounded-full object-cover'
  />
)
